// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { toast } from "sonner";
// import Benefit from "./Benefit";

// const SuperAdminBenefit = () => {
//   const [jobSeekers, setJobSeekers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);

//   // Fetch job seekers and benefits
//   useEffect(() => {
//     const fetchJobSeekers = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}benefit/getallBenefit`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });
//         // Group benefits by job seeker
//         const benefits = response.data.data;
//         const jobSeekerMap = new Map();
//         benefits.forEach((benefit) => {
//           const js = benefit.applicantId;
//           if (js) {
//             if (!jobSeekerMap.has(js._id)) {
//               jobSeekerMap.set(js._id, { ...js, benefits: [] });
//             }
//             jobSeekerMap.get(js._id).benefits.push(benefit);
//           }
//         });
//         setJobSeekers(Array.from(jobSeekerMap.values()));
//       } catch (err) {
//         setError(err.message || "Failed to fetch benefits");
//         toast.error("Error fetching benefits");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobSeekers();
//   }, []);

//   // Update benefit status
//   const updateBenefitStatus = async (benefitId, status, amountRequested) => {
//     try {
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_URL}benefit/update/${benefitId}`,
//         {
//           benefitStatus: status,
//           benefitBalance: status === "Approved" ? amountRequested : "0",
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setJobSeekers((prev) =>
//         prev.map((js) => ({
//           ...js,
//           benefits: js.benefits.map((b) =>
//             b._id === benefitId ? { ...b, ...response.data.data } : b
//           ),
//         }))
//       );
//       toast.success(`Benefit ${status.toLowerCase()} successfully`);
//     } catch (err) {
//       toast.error("Error updating benefit status");
//     }
//   };

//   // Calculate benefits for a given salary
//   const calculateBenefits = (grossSalary) => ({
//     essential: parseFloat(grossSalary || 0) * 0.1,
//     health: parseFloat(grossSalary || 0) * 0.05,
//   });

//   // Get total benefits paid
//   const getTotalBenefits = (benefits) => {
//     const totals = { essential: 0, health: 0, all: 0 };
//     benefits?.forEach((benefit) => {
//       if (benefit.benefitStatus === "Approved") {
//         const amount = parseFloat(benefit.amountRequested);
//         totals[benefit.benefitType] += amount;
//         totals.all += amount;
//       }
//     });
//     return totals;
//   };

//   // Handle details toggle
//   const toggleDetails = (jobSeeker) => {
//     setSelectedJobSeeker(selectedJobSeeker?._id === jobSeeker._id ? null : jobSeeker);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <h2 className="text-3xl font-bold text-gray-800 mb-6">Job Seeker Benefits</h2>
//       {loading ? (
//         <p className="text-gray-500">Loading benefits...</p>
//       ) : error ? (
//         <p className="text-red-500">Error: {error}</p>
//       ) : jobSeekers.length > 0 ? (
//         <div className="bg-white p-6 rounded-lg shadow-lg">
//           <table className="w-full text-sm md:text-base">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="py-2 px-4 text-left">Name</th>
//                 <th className="py-2 px-4 text-left">Total Essential Paid (₦)</th>
//                 <th className="py-2 px-4 text-left">Total Health Paid (₦)</th>
//                 <th className="py-2 px-4 text-left">Total Benefits Paid (₦)</th>
//                 <th className="py-2 px-4 text-left">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {jobSeekers.map((js) => (
//                 <React.Fragment key={js._id}>
//                   <tr className="border-t">
//                     <td className="py-2 px-4">{`${js.firstName} ${js.lastName}`}</td>
//                     <td className="py-2 px-4">{getTotalBenefits(js.benefits).essential.toLocaleString()}</td>
//                     <td className="py-2 px-4">{getTotalBenefits(js.benefits).health.toLocaleString()}</td>
//                     <td className="py-2 px-4">{getTotalBenefits(js.benefits).all.toLocaleString()}</td>
//                     <td className="py-2 px-4">
//                       <button
//                         onClick={() => toggleDetails(js)}
//                         className="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//                       >
//                         {selectedJobSeeker?._id === js._id ? "Hide Details" : "Show Details"}
//                       </button>
//                     </td>
//                   </tr>
//                   {selectedJobSeeker?._id === js._id && (
//                     <tr>
//                       <td colSpan="5" className="py-4 px-4 bg-gray-50">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                           <div>
//                             <h4 className="font-semibold">Personal Details</h4>
//                             <p><strong>Name:</strong> {`${js.firstName} ${js.middleName || ""} ${js.lastName}`}</p>
//                             <p><strong>Email:</strong> {js.email}</p>
//                             <p><strong>Phone:</strong> {js.phoneNumber}</p>
//                           </div>
//                           <div>
//                             <h4 className="font-semibold">Salary and Benefits</h4>
//                             {js.hiredHistory?.length > 0 && js.hiredHistory[0]?.salary?.history?.length > 0 ? (
//                               <>
//                                 <table className="w-full bg-gray-100 border border-gray-200 mt-2">
//                                   <thead>
//                                     <tr>
//                                       <th className="py-2 px-4 text-left">Period</th>
//                                       <th className="py-2 px-4 text-left">Gross Salary (₦)</th>
//                                       <th className="py-2 px-4 text-left">Essential Benefit (10%)</th>
//                                       <th className="py-2 px-4 text-left">Health Benefit (5%)</th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {js.hiredHistory[0].salary.history.map((hist, i) => {
//                                       const benefits = calculateBenefits(hist.grossSalary);
//                                       return (
//                                         <tr key={i} className="border-t">
//                                           <td className="py-2 px-4">{`${hist.month} ${hist.year}`}</td>
//                                           <td className="py-2 px-4">{(hist.grossSalary || 0).toLocaleString()}</td>
//                                           <td className="py-2 px-4">{benefits.essential.toLocaleString()}</td>
//                                           <td className="py-2 px-4">{benefits.health.toLocaleString()}</td>
//                                         </tr>
//                                       );
//                                     })}
//                                   </tbody>
//                                 </table>
//                                 <h5 className="font-semibold mt-4">Benefit Payment History</h5>
//                                 <table className="w-full bg-gray-100 border border-gray-200 mt-2">
//                                   <thead>
//                                     <tr>
//                                       <th className="py-2 px-4 text-left">Type</th>
//                                       <th className="py-2 px-4 text-left">Amount (₦)</th>
//                                       <th className="py-2 px-4 text-left">Period</th>
//                                       <th className="py-2 px-4 text-left">Status</th>
//                                       <th className="py-2 px-4 text-left">Date Requested</th>
//                                       <th className="py-2 px-4 text-left">Actions</th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {js.benefits?.length > 0 ? (
//                                       js.benefits.map((benefit, i) => (
//                                         <tr key={i} className="border-t">
//                                           <td className="py-2 px-4 capitalize">{benefit.benefitType}</td>
//                                           <td className="py-2 px-4">{parseFloat(benefit.amountRequested).toLocaleString()}</td>
//                                           <td className="py-2 px-4">{benefit.benefitDescription.split(" for ")[1] || "N/A"}</td>
//                                           <td className="py-2 px-4">
//                                             <span
//                                               className={
//                                                 benefit.benefitStatus === "Approved"
//                                                   ? "text-green-600"
//                                                   : benefit.benefitStatus === "Rejected"
//                                                   ? "text-red-600"
//                                                   : "text-yellow-600"
//                                               }
//                                             >
//                                               {benefit.benefitStatus}
//                                             </span>
//                                           </td>
//                                           <td className="py-2 px-4">{new Date(benefit.createdAt).toLocaleString()}</td>
//                                           <td className="py-2 px-4">
//                                             {benefit.benefitStatus === "Pending" && (
//                                               <div className="flex gap-2">
//                                                 <button
//                                                   onClick={() => updateBenefitStatus(benefit._id, "Approved", benefit.amountRequested)}
//                                                   className="px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600"
//                                                 >
//                                                   Approve
//                                                 </button>
//                                                 <button
//                                                   onClick={() => updateBenefitStatus(benefit._id, "Rejected", "0")}
//                                                   className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
//                                                 >
//                                                   Reject
//                                                 </button>
//                                               </div>
//                                             )}
//                                           </td>
//                                         </tr>
//                                       ))
//                                     ) : (
//                                       <tr>
//                                         <td colSpan="6" className="py-2 px-4 text-center">
//                                           No benefit payments made
//                                         </td>
//                                       </tr>
//                                     )}
//                                   </tbody>
//                                 </table>
//                                 <div className="mt-4">
//                                   <p><strong>Total Essential Benefit Paid:</strong> ₦{getTotalBenefits(js.benefits).essential.toLocaleString()}</p>
//                                   <p><strong>Total Health Benefit Paid:</strong> ₦{getTotalBenefits(js.benefits).health.toLocaleString()}</p>
//                                   <p><strong>Total All Benefits Paid:</strong> ₦{getTotalBenefits(js.benefits).all.toLocaleString()}</p>
//                                 </div>
//                               </>
//                             ) : (
//                               <p>No salary or benefit payment history available</p>
//                             )}

//                           </div>

//                         </div>
//                       </td>
//                     </tr>
//                   )}
                
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p className="text-gray-500">No job seekers with benefits found.</p>
//       )}
//         <Benefit/>
//     </div>
//   );
// };

// export default SuperAdminBenefit;




import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Benefit from "./Benefit";

const SuperAdminBenefit = () => {
  const [jobSeekers, setJobSeekers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);

  // Fetch job seekers, benefits, and employee data
  useEffect(() => {
    const fetchJobSeekers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}benefit/getallBenefit`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // Group benefits by job seeker
        const benefits = response.data.data;
        const jobSeekerMap = new Map();
        for (const benefit of benefits) {
          const js = benefit.applicantId;
          if (js) {
            if (!jobSeekerMap.has(js._id)) {
              // Fetch employee data if hiredHistory is unavailable
              let salaryHistory = [];
              if (!js.hiredHistory?.length || !js.hiredHistory[0]?.salary?.history?.length) {
                try {
                  const employeeResponse = await axios.get(
                    `${process.env.REACT_APP_API_URL}employer-employee/getByJobSeeker/${js._id}`,
                    {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                      },
                    }
                  );
                  salaryHistory = employeeResponse.data.data?.salary?.history || [];
                } catch (err) {
                  console.warn(`No employee data found for jobSeeker ${js._id}`);
                }
              } else {
                salaryHistory = js.hiredHistory[0].salary.history;
              }
              jobSeekerMap.set(js._id, { ...js, benefits: [], salaryHistory });
            }
            jobSeekerMap.get(js._id).benefits.push(benefit);
          }
        }
        setJobSeekers(Array.from(jobSeekerMap.values()));
      } catch (err) {
        setError(err.message || "Failed to fetch benefits");
        toast.error("Error fetching benefits");
      } finally {
        setLoading(false);
      }
    };
    fetchJobSeekers();
  }, []);

  // Update benefit status
  const updateBenefitStatus = async (benefitId, status, amountRequested) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}benefit/update/${benefitId}`,
        {
          benefitStatus: status,
          benefitBalance: status === "Approved" ? amountRequested : "0",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setJobSeekers((prev) =>
        prev.map((js) => ({
          ...js,
          benefits: js.benefits.map((b) =>
            b._id === benefitId ? { ...b, ...response.data.data } : b
          ),
        }))
      );
      toast.success(`Benefit ${status.toLowerCase()} successfully`);
    } catch (err) {
      toast.error("Error updating benefit status");
    }
  };

  // Calculate benefits for a given salary
  const calculateBenefits = (grossSalary) => ({
    essential: parseFloat(grossSalary || 0) * 0.1,
    health: parseFloat(grossSalary || 0) * 0.05,
  });

  // Get total benefits paid
  const getTotalBenefits = (benefits) => {
    const totals = { essential: 0, health: 0, all: 0 };
    benefits?.forEach((benefit) => {
      if (benefit.benefitStatus === "Approved") {
        const amount = parseFloat(benefit.amountRequested);
        totals[benefit.benefitType] += amount;
        totals.all += amount;
      }
    });
    return totals;
  };

  // Handle details toggle
  const toggleDetails = (jobSeeker) => {
    setSelectedJobSeeker(selectedJobSeeker?._id === jobSeeker._id ? null : jobSeeker);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">Job Seeker Benefits</h2>
      {loading ? (
        <p className="text-gray-500">Loading benefits...</p>
      ) : error ? (
        <p className="text-red-500">Error: {error}</p>
      ) : jobSeekers.length > 0 ? (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <table className="w-full text-sm md:text-base">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Name</th>
                <th className="py-2 px-4 text-left">Total Essential Paid (₦)</th>
                <th className="py-2 px-4 text-left">Total Health Paid (₦)</th>
                <th className="py-2 px-4 text-left">Total Benefits Paid (₦)</th>
                <th className="py-2 px-4 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {jobSeekers.map((js) => (
                <React.Fragment key={js._id}>
                  <tr className="border-t">
                    <td className="py-2 px-4">{`${js.firstName} ${js.lastName}`}</td>
                    <td className="py-2 px-4">{getTotalBenefits(js.benefits).essential.toLocaleString()}</td>
                    <td className="py-2 px-4">{getTotalBenefits(js.benefits).health.toLocaleString()}</td>
                    <td className="py-2 px-4">{getTotalBenefits(js.benefits).all.toLocaleString()}</td>
                    <td className="py-2 px-4">
                      <button
                        onClick={() => toggleDetails(js)}
                        className="px-3 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                      >
                        {selectedJobSeeker?._id === js._id ? "Hide Details" : "Show Details"}
                      </button>
                    </td>
                  </tr>
                  {selectedJobSeeker?._id === js._id && (
                    <tr>
                      <td colSpan="5" className="py-4 px-4 bg-gray-50">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <h4 className="font-semibold">Personal Details</h4>
                            <p><strong>Name:</strong> {`${js.firstName} ${js.middleName || ""} ${js.lastName}`}</p>
                            <p><strong>Email:</strong> {js.email}</p>
                            <p><strong>Phone:</strong> {js.phoneNumber}</p>
                          </div>
                          <div>
                            <h4 className="font-semibold">Salary and Benefits</h4>
                            {js.salaryHistory?.length > 0 ? (
                              <>
                                <table className="w-full bg-gray-100 border border-gray-200 mt-2">
                                  <thead>
                                    <tr>
                                      <th className="py-2 px-4 text-left">Period</th>
                                      <th className="py-2 px-4 text-left">Gross Salary (₦)</th>
                                      <th className="py-2 px-4 text-left">Essential Benefit (10%)</th>
                                      <th className="py-2 px-4 text-left">Health Benefit (5%)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {js.salaryHistory.map((hist, i) => {
                                      const benefits = calculateBenefits(hist.grossSalary);
                                      return (
                                        <tr key={i} className="border-t">
                                          <td className="py-2 px-4">{`${hist.month} ${hist.year}`}</td>
                                          <td className="py-2 px-4">{(hist.grossSalary || 0).toLocaleString()}</td>
                                          <td className="py-2 px-4">{benefits.essential.toLocaleString()}</td>
                                          <td className="py-2 px-4">{benefits.health.toLocaleString()}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                {/* <h5 className="font-semibold mt-4">Benefit Payment History</h5>
                                <table className="w-full bg-gray-100 border border-gray-200 mt-2">
                                  <thead>
                                    <tr>
                                      <th className="py-2 px-4 text-left">Type</th>
                                      <th className="py-2 px-4 text-left">Amount (₦)</th>
                                      <th className="py-2 px-4 text-left">Period</th>
                                      <th className="py-2 px-4 text-left">Status</th>
                                      <th className="py-2 px-4 text-left">Date Requested</th>
                                      <th className="py-2 px-4 text-left">Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {js.benefits?.length > 0 ? (
                                      js.benefits.map((benefit, i) => (
                                        <tr key={i} className="border-t">
                                          <td className="py-2 px-4 capitalize">{benefit.benefitType}</td>
                                          <td className="py-2 px-4">{parseFloat(benefit.amountRequested).toLocaleString()}</td>
                                          <td className="py-2 px-4">{benefit.benefitDescription.split(" for ")[1] || "N/A"}</td>
                                          <td className="py-2 px-4">
                                            <span
                                              className={
                                                benefit.benefitStatus === "Approved"
                                                  ? "text-green-600"
                                                  : benefit.benefitStatus === "Rejected"
                                                  ? "text-red-600"
                                                  : "text-yellow-600"
                                              }
                                            >
                                              {benefit.benefitStatus}
                                            </span>
                                          </td>
                                          <td className="py-2 px-4">{new Date(benefit.createdAt).toLocaleString()}</td>
                                          <td className="py-2 px-4">
                                            {benefit.benefitStatus === "Pending" && (
                                              <div className="flex gap-2">
                                                <button
                                                  onClick={() => updateBenefitStatus(benefit._id, "Approved", benefit.amountRequested)}
                                                  className="px-3 py-1 bg-green-500 text-white rounded-md hover:bg-green-600"
                                                >
                                                  Approve
                                                </button>
                                                <button
                                                  onClick={() => updateBenefitStatus(benefit._id, "Rejected", "0")}
                                                  className="px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
                                                >
                                                  Reject
                                                </button>
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="6" className="py-2 px-4 text-center">
                                          No benefit payments made
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table> */}
                                <div className="mt-4">
                                  <p><strong>Total Essential Benefit Paid:</strong> ₦{getTotalBenefits(js.benefits).essential.toLocaleString()}</p>
                                  <p><strong>Total Health Benefit Paid:</strong> ₦{getTotalBenefits(js.benefits).health.toLocaleString()}</p>
                                  <p><strong>Total All Benefits Paid:</strong> ₦{getTotalBenefits(js.benefits).all.toLocaleString()}</p>
                                </div>
                              </>
                            ) : (
                              <p>No salary or benefit payment history available</p>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500">No job seekers with benefits found.</p>
      )}
      <Benefit />
    </div>
  );
};

export default SuperAdminBenefit;